import {
  listAssessmentEvents as listAssessmentEventsQuery,
  getAssessmentById as getAssessmentByIdQuery,
  getActiveUsers as getActiveUsersQuery
} from 'graphql/operations';
import { compareDates } from 'utils/dateTime/converter';

const FIELD_STATE_TYPENAME = 'AssessmentEvent';

function getModelInstance(fields = {}, previous = {}) {
  return {
    ...previous,
    __typename: FIELD_STATE_TYPENAME,
    ...fields
  };
}

const UserTypingConfig = {
  resolvers: {
    Query: {
      getAssessmentEventById(_, { fieldId, eventType }, { cache }) {
        const cacheData = cache.readQuery({ query: listAssessmentEventsQuery });

        const currentFieldCacheData = cacheData.listAssessmentEvents.find(node => node.fieldId === fieldId && node.eventType === eventType);
        return currentFieldCacheData;
      },
      getLatestAssessmentEventById(_, { fieldId }, { cache }) {
        const cacheData = cache.readQuery({ query: listAssessmentEventsQuery });

        const currentFieldsCacheData = cacheData.listAssessmentEvents.filter(node => node.fieldId === fieldId);

        let event = null;
        if (currentFieldsCacheData.length === 1) {
          [event] = currentFieldsCacheData;
        } else if (currentFieldsCacheData.length > 1) {
          event =
            compareDates(currentFieldsCacheData[0].eventTime, currentFieldsCacheData[1].eventTime) < 0
              ? currentFieldsCacheData[0]
              : currentFieldsCacheData[1];
        }
        return event;
      }
    },
    Mutation: {
      updateActiveUsers: (_, { assessmentId, user, action }, { cache }) => {
        const prev = cache.readQuery({ query: getActiveUsersQuery, variables: { id: assessmentId } });

        const updatedList = [...prev.getActiveUsers.activeUsers];
        if (action === 'OPEN') {
          if (updatedList.findIndex(u => u.email === user.email) === -1) {
            updatedList.push(user);
          }
        } else if (action === 'CLOSE') {
          const userIndex = updatedList.findIndex(u => u.email === user.email);
          if (userIndex !== -1) {
            updatedList.splice(userIndex, 1);
          }
        }

        const newAssessment = {
          ...prev.getActiveUsers,
          activeUsers: updatedList
        };
        cache.writeQuery({ query: getActiveUsersQuery, variables: { id: assessmentId }, data: { getActiveUsers: newAssessment } });
        return newAssessment;
      },

      updateAssessmentStatus: (_, { assessmentId, status }, { cache }) => {
        const prev = cache.readQuery({ query: getAssessmentByIdQuery, variables: { id: assessmentId } });

        const newAssessment = {
          ...prev.getAssessmentById,
          status
        };

        cache.writeQuery({ query: getAssessmentByIdQuery, variables: { id: assessmentId }, data: { getAssessmentById: newAssessment } });
        return newAssessment;
      },

      updateAssessmentEvent: (_, variables, { cache }) => {
        const prev = cache.readQuery({ query: listAssessmentEventsQuery });
        const currentFieldIndex = prev.listAssessmentEvents.findIndex(
          node => node.fieldId === variables.fieldId && node.eventType === variables.eventType
        );

        const updatedList = [...prev.listAssessmentEvents];
        let fieldUpdateData;
        if (currentFieldIndex !== -1) {
          fieldUpdateData = getModelInstance({ ...variables }, prev.listAssessmentEvents[currentFieldIndex]);
          updatedList.splice(currentFieldIndex, 1, fieldUpdateData);
        } else {
          fieldUpdateData = getModelInstance({ ...variables });
          updatedList.push(fieldUpdateData);
        }

        const data = { listAssessmentEvents: updatedList };
        cache.writeQuery({ query: listAssessmentEventsQuery, data });

        return fieldUpdateData;
      },

      deleteAssessmentEvent: (_, { fieldId, eventType }, { cache }) => {
        const previous = cache.readQuery({ query: listAssessmentEventsQuery });
        const currentFieldIndex = previous.listAssessmentEvents.findIndex(node => node.fieldId === fieldId && node.eventType === eventType);

        if (currentFieldIndex !== -1) {
          const newData = [...previous.listAssessmentEvents];
          newData.splice(currentFieldIndex, 1);

          const data = { listAssessmentEvents: newData };

          cache.writeQuery({ query: listAssessmentEventsQuery, data });
        }
        return null;
      }
    }
  }
};

export default UserTypingConfig;
